import { withIconWrapper } from '@/hocs/withIconWrapper';

import ReactComponent from './IconShieldCheck.c.svg?react';

export const IconShieldCheck = withIconWrapper(ReactComponent);
